import React from "react";

const Introduction = () => {
  return (
    <div className="intro-text">
      <h1 className="display-4">
        Hello World!
        <span style={{ color: "#a5a5ff" }}> I'm Zaheer Baig</span>
      </h1>
      <p className="lead mt-3">
        I'm a software developer with 2 years of experience in building
        efficient, user-centric solutions. Skilled in both{" "}
        <span style={{ color: "#007bff" }}>front-end</span> and back-end
        technologies, I'm passionate about developing innovative applications
        that enhance user experience. I thrive in dynamic environments,
        consistently aiming to deliver high-quality code and impactful products.
      </p>
    </div>
  );
};

export default Introduction;
